import logoVihs from '../../img/LogoVihs.svg';
import './VihsMark.css';

export default function VihsMark({ className = '' }) {
  return (
    <img
      className={`vihs-mark${className ? ` ${className}` : ''}`}
      src={logoVihs}
      alt=""
      role="img"
      aria-hidden="true"
      draggable={false}
    />
  );
}
